import { SelectedPartnerTab } from '../SelectedPartnerTab';
import { StatsWithTarget } from '@urbanx/agx.rex.client';

import { AgencyModel, PartnershipDetailsPartnershipLevel } from '@urbanx/agx.agencies.client';

const exportStatisticsData = (numbers: StatsWithTarget) => {
  const { statistics, goals, statsAboveTarget } = numbers || {};

  let csvString =
    `Sales Volume,Sales Volume Goal,Amount above Sales Volume Goal,` +
    `GCI,GCI Goal,Amount above GCI goal,` +
    `Listings,Listings Goal,Amount above listings goal,` +
    `Sales,Sales Goal,Amount above sales goal,` +
    `Conversion Rate,Conversion Rate Goal,Amount above conversion rate goal,` +
    `Average Sale Price,Average Sale Price Goal,Amount above average sale price goal,` +
    `Average Commission Rate,Average Commission Rate Goal,Amount above average commission rate goal\n`;

  csvString +=
    `${statistics?.salesVolume},${goals?.salesVolume},${statsAboveTarget?.salesVolume},` +
    `${statistics?.grossCommissionIncome},${goals?.grossCommissionIncome},${statsAboveTarget?.grossCommissionIncome},` +
    `${statistics?.numberOfListings},${goals?.numberOfListings},${statsAboveTarget?.numberOfListings},` +
    `${statistics?.totalSales},${goals?.totalSales},${statsAboveTarget?.totalSales},` +
    `${statistics?.conversionRate},${goals?.conversionRate},${statsAboveTarget?.conversionRate},` +
    `${statistics?.averageSalePrice},${goals?.averageSalePrice},${statsAboveTarget?.averageSalePrice},` +
    `${statistics?.averageCommissionRate},${goals?.averageCommissionRate},${statsAboveTarget?.averageCommissionRate}\n`;

  return csvString;
};

export const exportStatsToCSV = (
  agency: AgencyModel | undefined,
  selectedTab: SelectedPartnerTab,
  startDate: string,
  endDate: string,
  stats: StatsWithTarget,
  partnershipLevel: PartnershipDetailsPartnershipLevel | undefined
) => {
  const csvString = exportStatisticsData(stats);
  const title = agency?.name?.replaceAll(' ', '_') || 'export';
  let filename = title;

  if (selectedTab === SelectedPartnerTab.Statistics) {
    filename = `${title}_numbers_${startDate}_to_${endDate}.csv`;
  } else if (selectedTab === SelectedPartnerTab.Partnership) {
    filename = `${title}_partnership_${partnershipLevel?.toString().replaceAll(' ', '_')}.csv`;
  }

  return [filename, csvString];
};
